import React from "react";
import PreviewImg from "../atoms/PreviewImg";
import PreviewTitle from "../atoms/PreviewTitle";
import {useSelector} from "react-redux";
import usePreviewColor from "./usePreviewColor";
import {useShootingPoint} from "../../../../hooks/controller/useShootingPoint";

const ColorOption = ({
                           code,
                           colorItemObject,
                           navigationDataObject,
                           stepObject,
                           slideToSubHandler,
                           targetDepth = "3",
                           showHeader = false,
                           headerTitle = null,
                           visible = true,
                           disableOptionClick = false
                         }) => {
  const sendData = useSelector(state => state.optionWindow.CONFIG_DATA);
  const langData = useSelector(state => state.theme.langData);
  const colorTarget = colorItemObject?.colorTarget;
  const {currentColor} = usePreviewColor(code, colorItemObject);
  const {shootingPointChangeHandler} = useShootingPoint(code, navigationDataObject.linkPath);

  const handleClick = (e) => {
    if (!colorItemObject || !code) return;

    shootingPointChangeHandler(e, stepObject, colorTarget);
    slideToSubHandler({
      id: navigationDataObject.id,
      stepId: colorItemObject.id,
      colorTarget: colorItemObject.colorTarget,
      targetDepth
    });
  };

  if (!visible) return null;

  return (
    <>
      {showHeader && (
        <div className={"option-h3"}>
          <div className={"option-value"} onClick={handleClick}>
            <div className={"option-value-name"}>
              <h2>{headerTitle}</h2>
            </div>
          </div>
        </div>
      )}

      <div className={"option-h3"} data-value={!!sendData[code]}>
        <div className={"option-value"} onClick={disableOptionClick ? undefined : handleClick}>
          <PreviewImg currentColor={currentColor} code={code} type={"COLOR"}/>
          <PreviewTitle title={colorItemObject?.[langData.langName]} currentColor={currentColor} type={"COLOR"}/>
        </div>
      </div>
    </>
  );
}
export default ColorOption;
